import { useContext } from "react";
import { useParams } from "react-router-dom";

import { DatasetEditorContext } from "@/components/DatasetEditor";
import { useChannel } from "@/components/Messaging/useChannel";
import { WEBSOCKET_MESSAGE_NAME } from "@/constants";
import { useUser } from "@/context/user-context";
import { ToastType } from "@/enums";
import { displayErrorToast, displayToast } from "@/utils/toast";

export const useDatasetExportProgress = () => {
  const { user } = useUser();
  const { datasetId } = useParams();
  const context = useContext(DatasetEditorContext);

  useChannel(
    `user:${user?.id}`,
    WEBSOCKET_MESSAGE_NAME.DATASET_FILE_PROCESSING_PROGRESS,
    socketMessage => {
      const data = JSON.parse(socketMessage.data);

      if (data.dataset_id !== Number(datasetId)) {
        return;
      }

      if (data?.payload?.type === "dataset_csv_export") {
        if (context?.processingType !== "export") {
          context?.setProcessingType?.("export");
        }
        context?.setProcessingProgress?.(Math.round(data.payload.progress));
      }
    },
  );

  useChannel(
    `user:${user?.id}`,
    WEBSOCKET_MESSAGE_NAME.DATASET_FILE_PROCESSING_COMPLETE,
    socketMessage => {
      try {
        const data = JSON.parse(socketMessage.data);

        if (data.dataset_id !== Number(datasetId)) {
          return;
        }

        if (data?.type === "dataset_csv_export" && context?.processingType === "export") {
          const { success, message, s3_url } = data;

          if (success) {
            if (s3_url) {
              const link = document.createElement("a");
              link.href = s3_url;
              link.download = `dataset_${data.dataset_id}.csv`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }

            displayToast(message || "Dataset exported successfully", ToastType.success);
          } else {
            displayErrorToast(message || "Export failed");
          }
          context?.setProcessingProgress?.(0);
          context?.setProcessingType?.(null);
        }
      } catch {
        displayErrorToast("Error processing export completion.");
        context?.setProcessingProgress?.(0);
        context?.setProcessingType?.(null);
      }
    },
  );

  return null;
};
